import { routes } from '@linqpal/models'
import LocalStorage from '../../store/LocalStorage'
import { MESSAGE_TYPE } from './MessageProvider'
import axios from 'axios'
import store from '../../store'
import { paths } from '../../screens/links'

export const dropzoneOptions = {
  accept: [
    'application/pdf',
    'application/msword',
    'image/*',
    'application/zip',
  ],
  maxFiles: 1,
  maxSize: 50 * 1024 * 1024,
  multiple: false,
}

export const builderInvoiceUpload = (navigation, acceptedFiles, onSuccess) => {
  routes.file
    .upload(acceptedFiles.map((f) => f.name))
    .then(({ results }) => {
      store.setBusy(true)
      let uploads = []
      for (let f of acceptedFiles) {
        let r = results.find((r) => {
          console.log(r.file, f.name)
          return r.file === f.name
        })
        if (r.url) {
          let uploader = axios.create({ url: r.url, method: 'PUT', data: f })
          uploads.push(
            uploader
              .put(r.url, f)
              .then((e) => (e.status === 200 ? r : { result: 'failed' })),
          )
        }
      }
      return Promise.all(uploads)
    })
    .then((response) => {
      if (response[0].result === 'ok') {
        LocalStorage.set('invoice_document', response[0]).then(() => {
          if (onSuccess) onSuccess()
          else {
            navigation.navigate(paths.Console.Payables._self, {
              screen: paths.Console.Payables.InvoiceForm,
            })
          }
        })
      }
    })
    .finally(() => store.setBusy(false))
}

export const invoiceUploadError = (fileRejections, setMessage) => {
  fileRejections.forEach(({ file, errors }) => {
    errors.forEach((error) => {
      if (error.code === 'file-too-large') {
        setMessage(
          MESSAGE_TYPE.ERROR,
          'The file size should be less than 10 megabite',
        )
      } else {
        setMessage(MESSAGE_TYPE.ERROR, error.message)
      }
    })
  })
}
